import { Instance } from 'mobx-state-tree';
import { VisitOptimizeUnscheduledDtoModelBase } from './VisitOptimizeUnscheduledDtoModel.base';

/* The TypeScript type of an instance of VisitOptimizeUnscheduledDtoModel */
export interface VisitOptimizeUnscheduledDtoModelType extends Instance<typeof VisitOptimizeUnscheduledDtoModel.Type> {}

/* A graphql query fragment builders for VisitOptimizeUnscheduledDtoModel */
export { selectFromVisitOptimizeUnscheduledDto, visitOptimizeUnscheduledDtoModelPrimitives, VisitOptimizeUnscheduledDtoModelSelector } from './VisitOptimizeUnscheduledDtoModel.base';

/**
 * VisitOptimizeUnscheduledDtoModel
 */
export const VisitOptimizeUnscheduledDtoModel = VisitOptimizeUnscheduledDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
